import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css/bundle';

export default () => {

	const els = [...document.querySelectorAll('.service-carousel__row')]

	els.map(el => {

		const carouselEl = el.querySelector('.service-carousel')
		const carouselPrev = el.querySelector('.swiper-carousel__prev')	
		const carouselNext = el.querySelector('.swiper-carousel__next')

		if (!carouselEl) return null

		const swiper = new Swiper(carouselEl, {
			modules: [ Navigation, Autoplay ],
			speed: 500,
			slidesPerView: 1.5,
			slidesPerGroup: 1,
			allowTouchMove: true,
            centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
			},
            navigation: {
                nextEl: carouselNext,
                prevEl: carouselPrev,
            },
            breakpoints: {
				780: { 
					slidesPerView: 2,
					slidesPerGroup: 1,
					allowTouchMove: true,
				},
				1124: { 
					slidesPerView: 3,
					slidesPerGroup: 1,
					allowTouchMove: false,
				},
			},
		})

		const images = [...el.querySelectorAll('.service-carousel__image')]

		let exitTimer = null
		const exitDuration = 1250
		let previousActiveIndex = null
		const setActiveImage = () => {
			const activeSlide = swiper.slides[swiper.activeIndex]
			const activeIndex = activeSlide?.dataset?.index
			if (!activeIndex) return

			if (exitTimer) window.clearTimeout(exitTimer)
			const previousSlide = swiper.slides[swiper.previousIndex]
			const previousIndex = previousSlide?.dataset?.index || previousActiveIndex
			let previousImage = null
			let activeImage = null
			images.forEach(image => {
				const isActive = image.dataset?.index === activeIndex
				const isPrevious = image.dataset?.index === previousIndex
				image.classList.toggle('is-active', isActive)
				image.classList.toggle('is-entering', isActive)
				image.classList.toggle('is-exiting', isPrevious)
				image.classList.remove('is-exit-run')
				if (image.dataset?.index === previousIndex) {
					previousImage = image
				}
				if (isActive) {
					activeImage = image
				}
				if (!isActive && !isPrevious) {
					image.classList.remove('is-entering')
					image.classList.remove('is-exiting')
				}
			})

			if (previousImage && previousIndex !== activeIndex) {
				requestAnimationFrame(() => {
					previousImage.classList.add('is-exit-run')
				})
			}

			if (activeImage) {
				requestAnimationFrame(() => {
					activeImage.classList.remove('is-entering')
				})
			}

			exitTimer = window.setTimeout(() => {
				images.forEach(image => {
					image.classList.remove('is-exiting')
					image.classList.remove('is-exit-run')
				})
			}, exitDuration)

			previousActiveIndex = activeIndex
		}

		setActiveImage()
		swiper.on('slideChange', setActiveImage)

		return swiper
	})
}



// import Swiper from 'swiper';
// import { Navigation } from 'swiper/modules';

// import 'swiper/css/bundle';

// export default () => {

// 	const els = Array.from(document.querySelectorAll('.service-carousel__row'))

// 	els.map(el => {

// 		const carouselEl = el.querySelector('.service-carousel')
// 		const carouselPrev = el.querySelector('.swiper-carousel__prev')
// 		const carouselNext = el.querySelector('.swiper-carousel__next')

// 		if (!carouselEl) return null

// 		const ensureOverlay = () => {
// 			let overlay = carouselEl.querySelector('.service-carousel__clip-overlay')
// 			if (!overlay) {
// 				overlay = document.createElement('div')
// 				overlay.className = 'service-carousel__clip-overlay'
// 				overlay.innerHTML = `
// 					<div class="layer old">
// 						<div class="box">
// 							<div class="img"></div>
// 							<div class="title"></div>
// 						</div>
// 					</div>
// 					<div class="layer new">
// 						<div class="box">
// 							<div class="img"></div>
// 							<div class="title"></div>
// 						</div>
// 					</div>
// 				`

// 				const computed = window.getComputedStyle(carouselEl)
// 				if (computed.position === 'static') carouselEl.style.position = 'relative'

// 				overlay.style.position = 'absolute'
// 				overlay.style.inset = '0'
// 				overlay.style.pointerEvents = 'none'
// 				overlay.style.zIndex = '2'
// 				overlay.style.opacity = '1'
// 				overlay.style.borderRadius = 'inherit'

// 				const layers = Array.from(overlay.querySelectorAll('.layer'))
// 				layers.forEach(layer => {
// 					layer.style.position = 'absolute'
// 					layer.style.inset = '0'
// 					layer.style.display = 'flex'
// 					layer.style.justifyContent = 'center'
// 					layer.style.alignItems = 'center'
// 					layer.style.willChange = 'clip-path'
// 					layer.style.borderRadius = 'inherit'
// 				})

// 				const boxes = Array.from(overlay.querySelectorAll('.box'))
// 				boxes.forEach(box => {
// 					box.style.display = 'flex'
// 					box.style.flexDirection = 'column'
// 					box.style.alignItems = 'center'
// 					box.style.textAlign = 'center'
// 					box.style.gap = '16px'
// 				})

// 				const imgs = Array.from(overlay.querySelectorAll('.img'))
// 				imgs.forEach(img => {
// 					img.style.width = '500px'
// 					img.style.height = '500px'
// 					img.style.backgroundRepeat = 'no-repeat'
// 					img.style.backgroundSize = 'contain'
// 					img.style.backgroundPosition = 'center'
// 				})

// 				const titles = Array.from(overlay.querySelectorAll('.title'))
// 				titles.forEach(title => {
// 					title.style.font = 'inherit'
// 					title.style.color = 'inherit'
// 				})

// 				carouselEl.appendChild(overlay)
// 			}
// 			return overlay
// 		}

// 		const swiper = new Swiper(carouselEl, {
// 			modules: [ Navigation ],
// 			speed: 500,
// 			slidesPerView: 1,
// 			slidesPerGroup: 1,
// 			loop: true,
//             navigation: {
//                 nextEl: carouselNext,
//                 prevEl: carouselPrev,
//             },
// 			breakpoints: {
// 				780: { 
// 					slidesPerView: 2,
// 					slidesPerGroup: 1
// 				},
// 				1124: { 
// 					slidesPerView: 3,
// 					slidesPerGroup: 1
// 				},
// 				1650: { 
// 					slidesPerView: 4,
// 					slidesPerGroup: 1
// 				},
// 			},
// 		})

// 		const overlay = ensureOverlay()
// 		const oldLayer = overlay.querySelector('.layer.old')
// 		const newLayer = overlay.querySelector('.layer.new')
// 		const oldImg = oldLayer.querySelector('.img')
// 		const newImg = newLayer.querySelector('.img')
// 		const oldTitle = oldLayer.querySelector('.title')
// 		const newTitle = newLayer.querySelector('.title')
// 		let running = []
// 		let ready = false

// 		const getSlideData = index => {
// 			const slide = swiper.slides[index]
// 			if (!slide) return { url: '', title: '' }
// 			const img = slide.querySelector('img')
// 			const url = img?.currentSrc || img?.src || ''
// 			const title = img?.getAttribute('data-title') || img?.alt || ''
// 			return { url, title }
// 		}

// 		const renderBaseState = data => {
// 			if (!data.url) return
// 			oldImg.style.backgroundImage = `url("${data.url}")`
// 			newImg.style.backgroundImage = `url("${data.url}")`
// 			oldTitle.textContent = data.title
// 			newTitle.textContent = data.title
// 			oldLayer.style.clipPath = 'inset(0 0 0 0)'
// 			newLayer.style.clipPath = 'inset(0 0 0 0)'
// 		}

// 		const runClipTransition = (fromData, toData) => {
// 			if (!ready) return
// 			if (!fromData.url || !toData.url || fromData.url === toData.url) {
// 				renderBaseState(toData.url ? toData : fromData)
// 				return
// 			}

// 			running.forEach(anim => anim.cancel())
// 			running = []

// 			oldImg.style.backgroundImage = `url("${fromData.url}")`
// 			newImg.style.backgroundImage = `url("${toData.url}")`
// 			oldTitle.textContent = fromData.title
// 			newTitle.textContent = toData.title

// 			oldLayer.style.clipPath = 'inset(0 50% 0 0)'
// 			newLayer.style.clipPath = 'inset(0 0 0 50%)'
// 			const duration = 5500
// 			const easing = 'cubic-bezier(0.2, 0.6, 0.2, 1)'

// 			const oldAnim = oldLayer.animate([
// 				{ clipPath: 'inset(0 50% 0 0)' },
// 				{ clipPath: 'inset(0 100% 0 0)' },
// 			], { duration, easing, fill: 'forwards' })

// 			const newAnim = newLayer.animate([
// 				{ clipPath: 'inset(0 0 0 50%)' },
// 				{ clipPath: 'inset(0 0 0 0)' },
// 			], { duration, easing, fill: 'forwards' })

// 			running.push(oldAnim, newAnim)

// 			Promise.all(running.map(anim => anim.finished))
// 				.then(() => {
// 					renderBaseState(toData)
// 				})
// 				.catch(() => {})
// 		}

// 		const whenImagesReady = cb => {
// 			const images = Array.from(carouselEl.querySelectorAll('img'))
// 			if (!images.length) {
// 				cb()
// 				return
// 			}
// 			let remaining = images.length
// 			const done = () => {
// 				remaining -= 1
// 				if (remaining <= 0) cb()
// 			}
// 			images.forEach(img => {
// 				if (img.complete) return done()
// 				img.addEventListener('load', done, { once: true })
// 				img.addEventListener('error', done, { once: true })
// 			})
// 		}

// 		// Initial render so overlay is always visible (after images resolve)
// 		whenImagesReady(() => {
// 			renderBaseState(getSlideData(swiper.activeIndex))
// 			// Keep originals for data, but hide the slide images visually.
// 			Array.from(carouselEl.querySelectorAll('img')).forEach(img => {
// 				img.style.opacity = '0'
// 				img.style.pointerEvents = 'none'
// 			})
// 			ready = true
// 		})

// 		swiper.on('slideChangeTransitionStart', () => {
// 			const fromData = getSlideData(swiper.previousIndex)
// 			const toData = getSlideData(swiper.activeIndex)
// 			runClipTransition(fromData, toData)
// 		})
// 	})

// }